import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from '~/components/atomic';
import { FullScreenLoading, HelmetHead, MypageList } from '~/components/common';
import { useModal } from '~/hooks';
import { ModalParams } from '~/types';
import { formatDate } from '~/utils';
import { PAGE_ROUTE } from '~/constants';
import AuthService from '~/services/AuthService';
import { useAuthStore, useUserStore } from '~/store';
import useToast from '~/store/useToast';
import * as S from './index.styled';

export default function Account() {
  const navigate = useNavigate();
  const { loginMethod } = useAuthStore();
  const { isLoading: isAuthLoading } = useAuthStore();

  const birth = useUserStore((state) => state.birth_date);
  const gender = useUserStore((state) => state.gender);
  const email = useUserStore((state) => state.email);

  const { openModal } = useModal();
  const { showToast } = useToast();

  const LogoutModalData: ModalParams = {
    type: 'double_red',
    title: 'Log out',
    content: 'Are you sure you want to sign out?',
    click: () => handleSignOut(),
    buttonName: 'Log out',
  };

  const DeleteUserModalData: ModalParams = {
    type: 'double_red',
    title: 'Delete account',
    content: 'Your account and all your chat data will be permanently deleted.',
    click: () => handleDeleteUser(),
    buttonName: 'Delete',
  };

  const userInfoArr = [
    {
      id: 'account_menu_01',
      menuName: 'Date of birth',
      rightInfo: formatDate(birth),
    },
    {
      id: 'account_menu_02',
      menuName: 'Gender',
      rightInfo: gender ?? '-',
    },
    {
      id: 'account_menu_03',
      menuName: 'Email',
      rightInfo: email,
    },
  ];

  const accountArr = [
    ...(loginMethod === 'email'
      ? [
          {
            id: 'account_menu_01',
            menuName: 'Change password',
            rightInfo: 'arrow',
            onClick: () => navigate(PAGE_ROUTE.CHANGE_PASSWORD),
          },
        ]
      : []),
    {
      id: 'account_menu_02',
      menuName: 'Log out',
      rightInfo: 'arrow',
      onClick: () => openModal(LogoutModalData),
    },
  ];

  const handleSignOut = async () => {
    const result = await AuthService.signOut();
    if (!result) return showToast('error', 'error sign out');
    navigate(PAGE_ROUTE.SIGNIN_HOME);
  };

  const handleDeleteUser = async () => {
    const result = await AuthService.deleteUser();
    if (!result) return showToast('error', 'error delete user');
    navigate(PAGE_ROUTE.SIGNIN_HOME);
  };

  useEffect(() => {
    const reload = (e: PageTransitionEvent) => {
      if (e.persisted) {
        window.location.reload();
      }
    };
    window.addEventListener('pageshow', reload);

    return () => {
      window.removeEventListener('pageshow', reload);
    };
  }, []);

  return (
    <>
      <HelmetHead title='Account' />

      {isAuthLoading && <FullScreenLoading />}
      <S.Container>
        <div>
          <MypageList arr={userInfoArr} mode='light' />
          <MypageList arr={accountArr} />

          <S.ButtonBox>
            <S.Button onClick={() => openModal(DeleteUserModalData)}>
              Delete account
              <Icon iconName={'ArrowRight'} size={20} />
            </S.Button>
          </S.ButtonBox>
        </div>
      </S.Container>
    </>
  );
}
